/**
 * DSP 支出侧 Invoice 的 **PDF 渲染状态**，与中台 InvoiceStatus 对齐。
 * 注意：不表示是否已提交给财务，提交状态见 DspInvoiceType.submitted。
 */
export enum DspInvoiceStatus {
    /** PDF 生成中 */
    INITIATED = 0,
    /** PDF 已生成 */
    PDF_READY = 1,
    /** PDF 生成失败 */
    FAILED = 2,
    /** 已作废 */
    CANCELLED = 3,
}

export interface DspInvoiceType {
    invoiceId: string;
    billId?: string | null;
    dspId?: string | null;
    invoiceNo?: string | null;
    /** 单位：厘 */
    invoiceAmount?: number | null;
    currency?: string | null;
    /** YYYYMMDD */
    invoiceDate?: number | null;
    /** PDF 渲染状态，见 DspInvoiceStatus */
    status?: number | null;
    /** 是否已提交给财务审核（依据账单 invoice_ids） */
    submitted?: boolean | null;
    generationType?: string | null;
    isSelfMade?: boolean | null;
    isParseFailed?: boolean | null;
    /** 为空表示 PDF 尚未渲染完，与文件类型无关；能否内嵌预览看 fileExtension */
    pdfPreviewUrl?: string | null;
    /** 下载文件名为 invoiceNo + 真实扩展名 */
    pdfDownloadUrl?: string | null;
    /** 原件文件名（DSP 上传自制件时的原始文件名），系统生成件为空 */
    fileName?: string | null;
    /** 原件扩展名，小写不含点（pdf/docx）；非 pdf 时不支持内嵌预览，走下载核对 */
    fileExtension?: string | null;
    version?: number | null;
    cancelReason?: string | null;
    cancelledAt?: number | null;
    createdAt?: number | null;
    /** Invoice 金额与账单结算金额是否不一致；仅总部接口计算，HUB / DSP Owner 为 null */
    amountMismatch?: boolean | null;
}

/**
 * 自制 Invoice 上传结果。此时原件已落 S3 但尚未生成 Invoice：
 * 解析值仅用于预填表单，需 DSP 确认或改写后调 confirmMySelfMadeDspInvoice 落库。
 */
export interface DspSelfMadeInvoiceUploadType {
    objectKey: string;
    fileName: string;
    /** 是否成功解析出 Invoice No 与 TOTAL AMOUNT DUE 两项；false 时走手填兜底 */
    parsed: boolean;
    invoiceNo?: string | null;
    /** 单位：分 */
    totalAmountDue?: number | null;
    failReason?: string | null;
}

export interface DspFinanceMissingFieldType {
    fieldName: string;
    label: string;
}
